module.exports = __webpack_public_path__ + "assets/img/return-4a06a915.png";